(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Server", [], factory);
	else if(typeof exports === 'object')
		exports["Server"] = factory();
	else
		root["Server"] = factory();
})(global, function() {
return 